import React from "react";
import Spinner from "../components/Spinner";
import moment from "moment/min/moment-with-locales";
moment.locale("pl");

/*
  ==-->>> TV VIEW <<<--==
*/

class RenderOneFishRowOnTv extends React.Component {
  state = {
    reminderTime: moment(this.props.fish.time.seconds * 1000).fromNow(),
  };

  componentDidMount() {
    this.interval = setInterval(this.updateReminderTime, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  updateReminderTime = () => {
    this.setState({
      reminderTime: moment(this.props.fish.time.seconds * 1000).fromNow(),
    });
  };

  render() {
    const m = this.props.fish;

    if (m.timeOnMarket) {
      if (m.time.seconds * 1000 + m.timeOnMarket * 3600 * 1000 < Date.now())
        return false;
    } else if (m.time.seconds * 1000 + 3 * 3600 * 1000 < Date.now()) {
      return false;
    }

    return (
      <div
        className="row my-2 border border-secondary border-left-0 border-right-0"
        style={{ backgroundColor: "#F8F9FB" }}
      >
        <div
          className="col-6 justify-content-center d-flex align-items-center"
          style={{ fontSize: "5rem" }}
        >
          {m.fishType.name}
        </div>
        <div className="col-6 justify-content-center d-flex align-items-center flex-column">
          <div>
            Dostępność: {m.amount} {m.fishType.amount.kg ? `kg` : `sztuk`},{" "}
            {m.price} zł/{m.fishType.amount.kg ? `kg` : `sztukę`}
          </div>
          <div>
            Kiedy: {this.state.reminderTime} (
            {moment(m.time.seconds * 1000).format("DD MMMM, H:mm")})
          </div>
        </div>
      </div>
    );
  }
}

class ManageAppScreen extends React.Component {
  async componentDidMount() {
    await this.props.getFishTypes();
    await this.props.getFishMarket(5);
    await this.props.getUserListWithType("fisherman");
    document.title = "Fishmarket Ustka"
  }

  joinMarketWithTypesAndFishers() {
    const { fishTypes, fishMarket } = this.props.fish,
      { fisherman } = this.props.users.userListWithType;
    return fishMarket.map((m) => {
      let fisher = fisherman.filter((f) => f.id === m.fisherId);
      let fishType = fishTypes.filter((f) => f.id === m.fishType);
      return { ...m, fisher: fisher[0], fishType: fishType[0] };
    });
  }

  generateFishMarketList() {
    let market = this.joinMarketWithTypesAndFishers();
    if (!market.length)
      return (
        <div
          className="container-fluid d-flex d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <div className="text-center">Oczekujemy na rybę</div>
        </div>
      );

    return (
      <div
        className="container-fluid d-flex d-flex align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="w-100 text-center">
          {market.map((m, key) => (
            <RenderOneFishRowOnTv fish={m} key={key} />
          ))}
        </div>
      </div>
    );
  }

  render() {
    const {
      fish: { fishTypes, fishMarket },
      users: { userListWithType },
    } = this.props;
    if (!fishTypes || !fishMarket || !userListWithType.fisherman)
      return <Spinner />;

    return this.generateFishMarketList();
  }
}

export default ManageAppScreen;



// WEBPACK FOOTER //
// ./src/screens/MainPageScreen.js